<template>
  <div class="reimbursementMiscalculationBox">
    <!-- header 界面 -->
    <trial-header></trial-header>
    <div class="SelectItemBox">
      <select-item ref="SelectItemRef"></select-item>
    <img v-if="originPath !== '1'" class="returnHome" src="@/assets/images/returnHome.png" alt="" @click="entry"/>

    </div>
    <div class="tabFooter">
      <tab-footer ref="tabFooterRef"></tab-footer>
    </div>
  </div>
</template>
<script>
import TrialHeader from './components/TrialHeader.vue';
import SelectItem from './components/SelectItem.vue';
import TabFooter from './components/TabFooter.vue';

export default {
  name: 'reimbursementMiscalculation',
  data() {
    return {
      originPath: '', // 请求来源 1、合伙人
    };
  },
  mounted() {
    this.originPath = this.$router.currentRoute.query.originPath;
  },
  methods: {
    entry() {
      this.$router.push('/supermarket/v2/');
    },
  },
  components: {
    SelectItem,
    TrialHeader,
    TabFooter,
  },
};
</script>
<style scoped>
.tabFooter {
  background-color: #fff;
}
.returnHome {
  width: 75px;
  height: 75px;
  position: fixed;
  bottom: 5%;
  right: 20px;
}
</style>
